import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "../pages/Home";
import About from "../pages/About";
import Services from "../pages/Services";
import Contact from "../pages/Contact";
import Membership from "../pages/Membership";
import PageNotFound from "../pages/PageNotFound";
import MembershipRegistration from "../pages/MembershipRegistration";
import Login from "../pages/Login";
import PaymentCheckout from "../pages/PaymentCheckout";
import PaymentStatus from "../pages/PaymentStatus";
import ImageGallery from "../pages/ImageGallery";
// import EmailVerify from "../pages/EmailVerify";
import OurMission from "../pages/OurMission";
import OurVision from "../pages/OurVision";
import OurLeadersipTeam from "../pages/OurLeadersipTeam";
import VideoGallery from "../pages/VideoGallery";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";
import PresentEvents from "../pages/PresentEvents";
import PastEvents from "../pages/PastEvents";
import Sponsors from "../pages/Sponsors";
import Restaurant from "../pages/Restaurant";
import ConventionHall from "../pages/ConventionHall";
import CategoryDetails from "../pages/CategoryDetails";
import ReviewRestaurant from "../pages/ReviewRestaurant";
import UpcomingEvents from "../pages/UpcomingEvents";
import ProShop from "../pages/ProShop";
import GolfCourse from "../pages/GolfCourse";
import EventDetailsPage from "../pages/EventDetailsPage";
import FacilitiesForGuests from "../pages/FacilitiesForGuests";
import FacilitiesForMembers from "../pages/FacilitiesForMembers";
// import VerifyEmail from "../pages/VerifyEmail";
import EmailVerifiedNotice from "../pages/EmailVerifiedNotice";
import ProtectedRoute from "../components/ProtectedRoute";
import MemberDashboard from "../pages/MemberDashboard";
import { useEffect, useState } from "react";
import api from "../api/axiosInstance";
import GolfStatisticsDashboard from "../pages/GolfStatisticsDashboard";
import GuestRoom from "../pages/GuestRoom";
import Profile from "../pages/Profile";
import MembershipDetails from "../pages/MembershipDetails";
import MenuGallery from "../pages/MenuGallery";

// import UpcomingEvents from "../pages/UpcomingEvents";

//---- Teamporary events data ----

// const parseEventDates = (dateStr) => {
//   const parts = dateStr.split("-");
//   if (parts.length === 2) {
//     // Date range: "15 - 17 May 2025"
//     const startDay = parts[0].trim();
//     const [endDay, month, year] = parts[1].trim().split(" ");
//     const startDate = new Date(`${startDay} ${month} ${year}`);
//     const endDate = new Date(`${endDay} ${month} ${year}`);
//     endDate.setHours(23, 59, 59, 999); // ensure it includes the full end day
//     return { startDate, endDate };
//   } else {
//     const date = new Date(dateStr);
//     date.setHours(0, 0, 0, 0);
//     const endDate = new Date(date);
//     endDate.setHours(23, 59, 59, 999);
//     return { startDate: date, endDate };
//   }
// };

// // Categorize events by today
// const categorizeEvents = (events) => {
//   const today = new Date();
//   return events.map((event) => {
//     const { startDate, endDate } = parseEventDates(event.date);
//     let category = "upcoming";
//     if (today < startDate) category = "upcoming";
//     else if (today >= startDate && today <= endDate) category = "present";
//     else category = "past";
//     return { ...event, category };
//   });
// };

// // sort events by date
// const sortEventsByDate = (events) => {
//   return [...events].sort((a, b) => {
//     const { startDate: startA } = parseEventDates(a.date);
//     const { startDate: startB } = parseEventDates(b.date);
//     return startB - startA; // descending order
//   });
// };

// const events = [
//   {
//     id: 1,
//     title: "President Cup Golf Tournament-2025",
//     date: "01 Feb 2025",
//     image: [
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759033751/president_cup_k6olw6.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759033375/2._President_Cup_Script_Prize_Distrb_List-2025-1_dgpvfe.png",

//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759033375/2._President_Cup_Script_Prize_Distrb_List-2025-1_dgpvfe.png",
//     ],
//   },
//   {
//     id: 2,
//     title: "Breakfast Cup Golf Tournament-2025",
//     date: "26 April 2025",
//     image: [
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758919429/breakfast_cup_1-min_jx5hoy.jpg",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758919422/breakfast_cup_2-min_cnn3mr.jpg",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758919417/breakfast_cup_3-min_qglauz.jpg",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758919412/breakfast_cup_7-min_fju6r3.jpg",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758919412/breakfast_cup_5-min_mksvxn.jpg",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758919411/breakfast_cup_4-min_yludng.jpg",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758919411/breakfast_cup_6-min_oowsfy.jpg",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759033445/1._Breakfast_Cup_Script_Prize_Distrb_List-2025_wejiyl.png",
//     ],
//   },
//   {
//     id: 3,
//     title: "Summer Cup Golf Tournament-2025",
//     date: "15 - 17 May 2025",
//     image: [
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758919417/summer_cup_4-min_ggd96y.jpg",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758919415/summer_cup_3-min_mcutni.jpg",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758919413/summer_cup_5-min_lffcvz.jpg",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758919412/summer_cup_1-min_nq2n4c.jpg",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758919411/summer_cup_2-min_v8bvrs.jpg",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758919411/summer_cup_6-min_qecwh8.jpg",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759033328/3._Summer_Cup_Script_Prize_Distrb_List-2025-1_obffmo.png",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759033328/3._Summer_Cup_Script_Prize_Distrb_List-2025-2_kxptdo.png",
//     ],
//   },
//   {
//     id: 4,
//     title: "Monsoon Cup Golf Tournament-2025",
//     date: "10 - 12 Jul 2025",
//     image: [
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758919419/monsoon_cup_3-min_npzrqw.jpg",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758919415/monsoon_cup_5-min_ddn7iu.jpg",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758919415/monsoon_cup_2-min_ovdm5q.jpg",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758919415/monsoon_cup_1-min_g0zylr.jpg",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758919413/monsoon_cup_4-min_yhcwxb.jpg",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759033264/4._Moonsoon_Cup_Script_Prize_Distrb_List-2025-1_nhhbwa.png",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759033265/4._Moonsoon_Cup_Script_Prize_Distrb_List-2025-2_gxbjb5.png",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759033265/4._Moonsoon_Cup_Script_Prize_Distrb_List-2025-3_izqu5c.png",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759033264/4._Moonsoon_Cup_Script_Prize_Distrb_List-2025-4_cwps2c.png",
//     ],
//   },
//   {
//     id: 5,
//     title: "July People's Uprising Day Breakfast Cup Golf Tournament-2025",
//     date: "05 Aug 2025",
//     image: [
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759033750/july_people_cup_wbfix8.jpg",
//     ],
//   },
//   {
//     id: 6,
//     title: "Sponsors Cup Golf Tournament-2025",
//     date: "10 - 14 Aug 2025",
//     image: [
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758919428/sponsors_cup_3-min_hkbqi6.jpg",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758919427/sponsors_cup_1-min_pfqujp.jpg",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758919421/sponsors_cup_5-min_ur1z3z.jpg",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758919420/sponsors_cup_7-min_t96sch.jpg",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758919420/sponsors_cup_6-min_h1vxy3.jpg",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758919415/sponsors_cup_4-min_hke5i3.jpg",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759033128/6._SPONSORS_CUP_Script_Prize_Distrb_List-2025-1_pg09tq.png",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759033128/6._SPONSORS_CUP_Script_Prize_Distrb_List-2025-2_ekebam.png",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759033128/6._SPONSORS_CUP_Script_Prize_Distrb_List-2025-3_y2odap.png",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759033127/6._SPONSORS_CUP_Script_Prize_Distrb_List-2025-4_wvny4p.png",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759033127/6._SPONSORS_CUP_Script_Prize_Distrb_List-2025-5_hwpwkb.png",
//     ],
//   },
//   {
//     id: 7,
//     title: "Winter Cup Golf Tournament-2025",
//     date: "01 - 02 Oct 2025",
//     image: [
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759507967/winter_cup_1_t3mr4t.jpg",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759507966/winter_cup_6_lzkvo5.jpg",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759507970/winter_cup_2_jeluhs.jpg",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759507968/winter_cup_11_p1xnxn.jpg",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759507970/winter_cup_4_qpecrh.png",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759507967/winter_cup_10_eqq8fs.jpg",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759507968/winter_cup_5_jm6pxm.png",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759507965/winter_cup_8_zgjnpd.jpg",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759507965/winter_cup_9_fuptas.jpg",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759507966/winter_cup_7_w36fkc.jpg",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759680671/7._Winter_Cup_Script_Prize_Distrb_List-2025_page-0001_iln7sb.jpg",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759680671/7._Winter_Cup_Script_Prize_Distrb_List-2025_page-0002_bwy0us.jpg",
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759680671/7._Winter_Cup_Script_Prize_Distrb_List-2025_page-0003_rnuoqv.jpg",
//     ],
//   },
// ];

const AppRouter = () => {
  const [events, setEvents] = useState([]);
  // const [loading, setLoading] = useState(true);
  // const sortedEvents = sortEventsByDate(events);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const res = await api.get("/events/get/all");
        setEvents(res.data);
      } catch (err) {
        console.error("Failed to fetch events:", err);
      } finally {
        // setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  const today = new Date();

  const upcomingEvents = events.filter((e) => {
    if (e.eventType) return e.eventType === "UPCOMING_EVENT";
    return new Date(e.startDate) > today;
  });

  const presentEvents = events.filter((e) => {
    if (e.eventType) return e.eventType === "PRESENT_EVENT";
    return new Date(e.startDate) <= today && new Date(e.endDate) >= today;
  });

  const pastEvents = events.filter((e) => {
    if (e.eventType) return e.eventType === "PAST_EVENT";
    return new Date(e.endDate) < today;
  });

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/mission" element={<OurMission />} />
      <Route path="/vision" element={<OurVision />} />
      <Route path="/leadership-team" element={<OurLeadersipTeam />} />

      <Route path="/services" element={<Services />} />
      <Route path="/restaurant" element={<Restaurant />} />
      <Route path="/menu-gallery" element={<MenuGallery />} />
      <Route path="/guest-room" element={<GuestRoom />} />
      <Route path="pro-shop" element={<ProShop />} />
      <Route path="/review" element={<ReviewRestaurant />} />
      <Route path="/category/:id" element={<CategoryDetails />} />
      <Route path="/convention-hall" element={<ConventionHall />} />
      <Route path="/golf-course" element={<GolfCourse />} />

      {/* <Route path="/image-gallery" element={<Gallery />} /> */}
      <Route path="/image-gallery" element={<ImageGallery />} />
      <Route path="/video-gallery" element={<VideoGallery />} />
      <Route path="/contact" element={<Contact />} />
      {/* <Route path="/events" element={<Events />} /> */}
      {/* <Route path="/events-list" element={<EventsListPage />} /> */}
      {/* <Route path="/appointment" element={<Appointment />} /> */}
      <Route path="/membership" element={<Membership />} />
      <Route
        path="/membership-registration"
        element={<MembershipRegistration />}
      />

      {/* events */}
      <Route
        path="/present-events"
        element={
          <PresentEvents events={presentEvents} title={"Present Events"} />
        }
      />
      <Route
        path="/past-events"
        element={<PastEvents events={pastEvents} title={"Past Events"} />}
      />
      <Route
        path="/upcoming-events"
        element={
          <UpcomingEvents events={upcomingEvents} title={"Upcoming Events"} />
        }
      />

      <Route path="/sponsors" element={<Sponsors />} />

      <Route path="/facilites-guests" element={<FacilitiesForGuests />} />
      <Route path="/facilites-members" element={<FacilitiesForMembers />} />

      {/* Protected Routes */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <MemberDashboard />
          </ProtectedRoute>
        }
      />

      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        }
      />

      <Route
        path="/membership-details"
        element={
          <ProtectedRoute>
            <MembershipDetails />
          </ProtectedRoute>
        }
      />

      {/* Add Golf Statistics Route */}
      <Route
        path="/golf-statistics"
        element={
          <ProtectedRoute>
            <GolfStatisticsDashboard />
          </ProtectedRoute>
        }
      />

      <Route
        path="/payment-checkout"
        element={
          <ProtectedRoute>
            <PaymentCheckout />
          </ProtectedRoute>
        }
      />

      <Route
        path="/events/:id"
        element={<EventDetailsPage events={events} />}
      />

      {/* <Route path="/registration-success" element={<VerificationResult />} /> */}
      {/* <Route path="/user/:id/verify/:token" element={<EmailVerify />} /> */}
      {/* <Route path="/check-email" element={<CheckEmail />} /> */}
      {/* <Route path="/verify-email" element={<VerifyEmail />} /> */}
      <Route path="/email-verified" element={<EmailVerifiedNotice />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/payment-status" element={<PaymentStatus />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default AppRouter;
